import { useEffect, useState } from "react";
import { api } from "../../api";
import { trackEvent } from "../../analytics";

export default function Sds({ dark, onRequestQuote }) {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    api.getSds().then(setDocs);
  }, []);

  return (
    <section className={"panel" + (dark ? " dark" : "")} id="sds" data-testid="section-sds">
      <div className="wrap">
        <div className="panel-head">
          <div className="eyebrow">Compliance · document vault</div>
          <h2>SDS library</h2>
          <p>
            Current-revision Safety Data Sheets, one per grade. In production these are versioned in
            a CMS or document store and re-issued whenever the formulation or regulation changes.
          </p>
        </div>
        <div className="sds-grid" data-testid="sds-grid">
          {docs.map((d, i) => (
            <div className="sds-card" key={i} data-testid={`sds-card-${d.chem_key}`}>
              <div className="sds-top">
                <h4 style={{ fontSize: 15 }}>{d.sub}</h4>
                <span className="rev-badge">{d.rev}</span>
              </div>
              <p style={{ fontSize: 12.5, color: dark ? "#9aa4ab" : "var(--ink-soft)", margin: 0 }}>
                PDF · GHS-compliant · English &amp; Hindi
              </p>
              <div className="sds-dl">
                <a
                  href="#sds"
                  onClick={(e) => {
                    e.preventDefault();
                    trackEvent("sds_download_clicked", { chemical: d.chem_key });
                  }}
                  data-testid={`sds-download-${d.chem_key}`}
                >
                  ↓ Download SDS.pdf
                </a>
                <button className="btn-link" onClick={() => onRequestQuote?.("sds")} data-testid={`sds-request-quote-${d.chem_key}`}>
                  Request quote
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
